import { IServerElement } from "../types/serverElements";

export const groupByGroupName = (array: IServerElement[]) => {
  /* Returns a dictionary {groupName.ToUpperCase: array sorted by priority}*/
  const groups: {[key:string]: IServerElement[]} = {};

  // Iterate through the original array
  for (const item of array) {
    const groupName = item.groupName.toUpperCase();

    // Create a new array for the group if it doesn't exist
    if (!groups[groupName]) {
      groups[groupName] = [];
    }

    // Push the item into its corresponding group array
    groups[groupName].push(item);
  }

  // Convert groups object to an array of arrays, sort within each group
  Object.values(groups).forEach((group) => group.sort((a, b) => a.priority - b.priority));
  return groups;
}